<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <FaqForm :baseFaq="faq" :baseName="name" :loading="loading" @submit-requested="submitRequested"></FaqForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import FaqForm from './FaqForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                faq: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { FaqForm },
        computed:
        {
            ...mapState('faqs', ['getFaqByIdOutput']),
        },
        methods: {
            ...mapActions('faqs', ['getFaqById']),
            ...mapActions('faqs', ['putFaq']),
            submitRequested(faq) {
                this.putFaq(faq);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({name: "Faqs"});
            }
            else {
                this.getFaqById(this.$route.query.id);
            }
        },
        watch:
        {
            getFaqByIdOutput: function (output) {
                if (!output) {
                    router.push({name: "Faqs"});
                }
                else {
                    this.faq = output;
                    this.loading = false;
                }
            }
        }
    }
</script>